import { env } from '@/config/env';
import { SettingsIcon } from '@/components/icons';
import { ROUTES } from '@/app/router/routes';
import { useAccess, canVisit } from '@/features/access/access';
import { Link, useLocation } from 'react-router';
import { cn } from '@/lib/utils/cn';
import { isModuleActive, NAV_ITEMS } from './navigation';
import './Sidebar.css';

export const Sidebar = () => {
  const access = useAccess();
  const { pathname } = useLocation();
  const version = env.VITE_APP_VERSION.replace(/^v(?=\d)/i, '');
  return (
    <aside className="platform-sidebar">
      <nav aria-label="Navigation principale" className="platform-sidebar-nav">
        {NAV_ITEMS.filter((item) => item.to && canVisit(access.data, item.to)).map(
          ({ label, to, icon: Icon }) => {
            const content = (
              <>
                <span className="sidebar-nav-symbol" aria-hidden="true">
                  <Icon className="sidebar-nav-icon" />
                </span>
                <span className="sidebar-nav-label">{label}</span>
              </>
            );
            if (!to) {
              return (
                <button
                  key={label}
                  type="button"
                  aria-disabled="true"
                  aria-label={label}
                  title={`${label} · À venir`}
                  className="sidebar-nav-item sidebar-nav-item--unavailable"
                >
                  {content}
                </button>
              );
            }
            const active = isModuleActive(pathname, to);
            return (
              <Link
                key={to}
                to={to}
                aria-label={label}
                title={label}
                aria-current={active ? 'page' : undefined}
                className={cn('sidebar-nav-item', active && 'sidebar-nav-item--active')}
              >
                {content}
              </Link>
            );
          },
        )}
      </nav>
      <nav aria-label="Configuration" className="platform-sidebar-footer">
        <Link
          to={ROUTES.settings}
          title="Paramètres"
          aria-label="Paramètres"
          aria-current={pathname.startsWith('/parametres') ? 'page' : undefined}
          className={cn(
            'sidebar-nav-item',
            pathname.startsWith('/parametres') && 'sidebar-nav-item--active',
          )}
        >
          <span className="sidebar-nav-symbol" aria-hidden="true">
            <SettingsIcon className="sidebar-nav-icon" />
          </span>
          <span className="sidebar-nav-label">Paramètres</span>
        </Link>
        <div className="sidebar-utilities">
          <span
            className="sidebar-release-version"
            aria-label={`Version ${version}`}
            title={`Version ${version}`}
          >
            v{version}
          </span>
        </div>
      </nav>
    </aside>
  );
};
